export default __webpack_public_path__ + "static/media/begin-animated.44c7fb1d.gif";